import React from 'react';
import { ArrowRight, CreditCard } from 'lucide-react';

export function N26PromoBanner() {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
      <div className="flex flex-col sm:flex-row items-center">
        {/* Logo Section */}
        <div className="w-full sm:w-auto p-4 sm:p-5 flex justify-center sm:justify-start">
          <div className="bg-black rounded-xl p-3 w-16 h-16 flex items-center justify-center">
            <span className="text-white text-2xl font-bold">N26</span>
          </div>
        </div>
        
        {/* Content Section */}
        <div className="flex-1 p-4 sm:p-5 sm:pl-0">
          <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-1">
            Banque mobile N26
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
            6 mois d'abonnement N26 Go offerts
          </p>
          <a 
            href="https://pvtistes.net/bonsplans/banque-mobile-n26/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 group"
          >
            <CreditCard className="w-3.5 h-3.5" />
            <span>Découvrir l'offre</span>
            <ArrowRight className="w-3.5 h-3.5 transform transition-transform group-hover:translate-x-0.5" />
          </a>
        </div>
      </div>
    </div>
  );
}